import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=d98c5d80&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=d98c5d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c5d80",
  null
  
)

export default component.exports